@import '~style-sheet-helpers/core.less';

.additional-charges-collapsible {
  .additional-charges-collapsible-list-section {
    border-bottom: none;
  }

  .additional-charges-collapsible-section-header {
    font-weight: @normal;
    font-size: 13px;
    padding-right: 25px;

    .additional-charges-collapsible-section-header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .additional-charges-collapsible-section-header-expander {
      border: none;
    }
  }

  .additional-charges-collapsible-section-content {
    padding-left: 16px;
  }
}
